import Swiper, { Navigation, Scrollbar } from 'swiper'

import './header.scss'

const selectors = {
  header: '[data-header]',
  menuTrigger: '[data-header-trigger]',

  accordion: '[data-header-accordion]',
  accordionHeader: '[data-header-accordion-header]',

  tab: '[data-header-tab]',
  tabHeader: '[data-header-tab-header]',
  tabPane: '[data-header-tab-pane]',

  active: 'active',
  fixed: 'fixed',
}

const setActiveTab = (tab, activeIndex, tabs, panes) => {
  const isActive = tab.classList.contains(selectors.active)

  tabs.forEach((tab) => tab.classList.remove(selectors.active))
  panes.forEach((pane, index) => pane.classList[index === activeIndex ? 'add' : 'remove'](selectors.active))
  panes[0].querySelector('.swiper').swiper.update()
  !isActive && tab.classList.toggle(selectors.active)
}

const initHeader = (header) => {
  const triggers = header.querySelectorAll(selectors.menuTrigger)
  const accordions = header.querySelectorAll(selectors.accordion)

  accordions?.forEach((accordion) => {
    const header = accordion.querySelector(selectors.accordionHeader)
    const sliders = accordion.querySelectorAll('.swiper')
    const tabs = accordion.querySelectorAll(selectors.tab)
    const panes = accordion.querySelectorAll(selectors.tabPane)

    header?.addEventListener('click', () => {
      const isActive = accordion.classList.contains(selectors.active)
      accordions.forEach((accordion) => accordion.classList.remove(selectors.active))
      !isActive && accordion.classList.toggle(selectors.active)
    })

    tabs?.forEach((tab, activeIndex) => {
      const header = tab.querySelector(selectors.tabHeader)

      header.addEventListener('click', () => setActiveTab(tab, activeIndex, tabs, panes))
    })

    sliders?.forEach((slider) => {
      new Swiper(slider, {
        modules: [Scrollbar, Navigation],

        slidesPerView: 3,
        spaceBetween: 8,

        scrollbar: {
          el: slider.parentElement.querySelector('.swiper-scrollbar'),
          draggable: true,
        },

        navigation: {
          prevEl: slider.parentElement.querySelector('.prev'),
          nextEl: slider.parentElement.querySelector('.next'),
        },

        breakpoints: {
          1024: {
            slidesPerView: 7,
          },
        },
      })
    })

    if (tabs.length && window.matchMedia('(min-width: 1024px)').matches) setActiveTab(tabs[0], 0, tabs, panes)
  })

  triggers?.forEach((trigger) =>
    trigger.addEventListener('click', () => {
      header.classList.toggle(selectors.active)
      document.body.classList.toggle(selectors.fixed)
    })
  )
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    const header = document.querySelector(selectors.header)

    if (!header) return

    initHeader(header)
  },
  { once: true }
)
